var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-row',[_c('b-col',[_c('parallax-page-header',{attrs:{"src":"/img/hero-shadowlands.jpg","title":"Silver River","extra-big":true,"z-index":-1,"text":"EU - Ragnaros","menu":_vm.menu}})],1),_c('div',{staticClass:"wild-horse"})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }